<template>
  <v-row justify="center">
    <v-col
      cols="12"
      :md="!view?12:8"
    >
      <base-material-card icon="mdi-account-outline">
        <template v-slot:after-heading>
          <div class="title font-weight-light">
            <span class="body-1">Физическое лицо</span>
            <v-spacer />
            <span class="body-2">{{ title }}
              <v-icon
                v-if="view && form.id!=null && ($store.state.user.role == 1 || $store.state.user.role == 2)"
                @click="view = false, change = true"
              >mdi-pencil</v-icon>
              <v-icon
                v-if="change && form.id!=null"
                @click="view = true, change = false"
              >mdi-eye</v-icon>
            </span>
          </div>
        </template>
        <base-material-tabs color="warning">
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
          >
            {{ tab }}
          </v-tab>
          <v-tab>
            Файлы
          </v-tab>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-select
                      v-model="form.types"
                      :items="select.type"
                      label="Тип физического лица"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.surname"
                      class="purple-input"
                      label="Фамилия"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.name"
                      label="Имя"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.patronymic"
                      label="Отчество"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="data.phone"
                      label="Телефон"
                      :counter="11"
                      maxlength="11"
                      :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                      prepend-icon="mdi-face"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="form.email"
                      label="E-mail"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="form.birthday"
                      label="Дата рождения"
                      type="date"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="form.birthplace"
                      label="Место рождения"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6" v-if="$store.state.user.role == 1">
                    <v-checkbox
                      v-model="form.insurer_agent"
                      label="Является представителем в СК"
                      />
                  </v-col>
                  <v-col cols="6" v-if="$store.state.user.role == 1">
                    <v-checkbox
                      v-model="form.contract_agent"
                      label="Является представителем для подписания договоров"
                      />
                  </v-col>
                  <v-col cols="6" v-if="$store.state.user.role == 1">
                    <v-checkbox
                      v-model="form.legal_agent"
                      label="Доступность заключения договоров юридических услуг"
                      />
                  </v-col>
                  <v-col cols="6" v-if="$store.state.user.role == 1">
                    <v-checkbox
                      v-model="form.own_cotracts"
                      label="Просмотр только своих договоров"
                      />
                  </v-col>
                  <v-col cols="6" v-if="$store.state.user.role == 1">
                    <v-select
                      :items="select.cities"
                      multiple
                      v-model="form.cities"
                      label="Выберите города"
                      />
                  </v-col>
                  <v-col cols="3" v-if="form.insurer_agent || form.contract_agent">
                    <v-select
                      v-model="form.agent_doc.type"
                      label="Тип документа"
                      :items="select.agent_doc_type"
                      />
                  </v-col>
                  <v-col cols="3" v-if=" (form.insurer_agent || form.contract_agent) && form.agent_doc.type == 2">
                    <v-text-field
                      v-model="form.agent_doc.number"
                      label="Номер доверенности"
                      />
                  </v-col>
                  <v-col cols="3" v-if=" (form.insurer_agent || form.contract_agent) && form.agent_doc.type == 2">
                    <v-text-field
                      v-model="form.agent_doc.from_date"
                      label="Дата выдачи"
                      type="date"
                      />
                  </v-col>
                  <v-col cols="3" v-if=" (form.insurer_agent || form.contract_agent) && form.agent_doc.type == 2">
                    <v-text-field
                      v-model="form.agent_doc.date"
                      label="Срок действия"
                      type="date"
                      />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container
                v-for="(item, index) in form.addresses"
                :key="index"
                class="py-0"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    {{ dict.address[item.type] }}
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="item.value"
                      label="Адрес"
                      class="purple-input"
                      :disabled="view"
                      :name="'address' + String(index)"
                      @input="adress_input(item, index)"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="item.data.postal_code"
                      label="Индекс"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="item.data.region_with_type"
                      label="Субъект федерации"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="item.data.city_with_type"
                      label="Город"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="item.data.street_with_type"
                      label="Улица"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container
                v-for="(item, index) in form.phones"
                :key="index"
                class="py-0"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="item.number"
                      label="Номер телефона"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                  >
                    <v-select
                      v-model="item.type"
                      label="Тип"
                      class="purple-input"
                      :disabled="view"
                      :items="select.phone"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-checkbox
                      v-model="item.main"
                      label="Основной номер"
                      class="purple-input"
                      :disabled="view"
                      @change="()=> {if (item.main) for (let x in form.phones) form.phones[x].main = false; item.main = true; if (item.main && item.type == 1) data.phone = item.number}"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="1"
                  >
                    <v-icon
                      large
                      @click="form.phones = form.phones.filter(a=>a!=item)"
                    >
                      mdi-minus
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="9"
                  >
                    <v-text-field
                      v-model="item.comment"
                      label="Комментарий"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="item.sms"
                      label="Согласие на СМС"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <v-icon
                large
                @click="form.phones.push({})"
              >
                mdi-plus
              </v-icon>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container
                v-for="(item, index) in form.documents"
                :key="index"
                class="py-0"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="11"
                  >
                    <v-select
                      v-model="item.type"
                      label="Тип документа"
                      class="purple-input"
                      :disabled="view"
                      :items="select.document"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="1"
                  >
                    <v-icon
                      :disabled="view"
                      large
                      @click="form.documents = form.documents.filter(a=>a!=item)"
                    >
                      mdi-minus
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="item.series"
                      label="Серия документа"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="item.number"
                      label="Номер документа"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="item.from"
                      label="Кем выдано"
                      class="purple-input"
                      :disabled="view"
                      :name="'doc_from_' + String(index)"
                      @input="doc_from_input(item, index)"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="item.date"
                      type="date"
                      label="Дата выдачи (при наличии)"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <v-icon
                :disabled="view"
                large
                @click="form.documents.push({})"
              >
                mdi-plus
              </v-icon>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container
                v-for="(item, index) in form.socials"
                :key="index"
                class="py-0"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="11"
                  >
                    <v-select
                      v-model="item.type"
                      label="Соц. сеть"
                      class="purple-input"
                      :disabled="view"
                      :items="select.social"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="1"
                  >
                    <v-icon
                      :disabled="view"
                      large
                      @click="form.socials = form.socials.filter(a=>a!=item)"
                    >
                      mdi-minus
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="item.link"
                      label="Ссылка на профиль"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="item.comment"
                      label="Комментарий"
                      class="purple-input"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <v-icon
                :disabled="view"
                large
                @click="form.socials.push({})"
              >
                mdi-plus
              </v-icon>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.requisites.name"
                      name="bank"
                      color="secondary"
                      label="Банк"
                      :disabled="view"
                      @input="bank_input"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.requisites.bic"
                      name="bic"
                      color="secondary"
                      label="Бик"
                      :disabled="view"
                      @input="bic_input"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.requisites.ks"
                      color="secondary"
                      label="К/с"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.requisites.rs"
                      color="secondary"
                      label="Р/с"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-row dense>
              <v-col cols="12">
                Транспортные средства
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-btn
                  :disabled="view"
                  color="primary"
                  min-width="150"
                  @click="show_vehicle_list_dialog"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-data-table
                  :headers="table.vehicle.headers"
                  :items="form.vehicles"
                  @click:row="(item)=>info.vehicle = item"
                >
                  <template v-slot:item.actions="{item}">
                    <v-icon
                      :disabled="view"
                      @click="show_vehicle_show_dialog(item)"
                    >
                      mdi-cog
                    </v-icon>
                    <v-icon
                      :disabled="view"
                      @click="form.vehicles = form.vehicles.filter(a=>a!=item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
                  <v-col
                    cols="5"
                  >
                    <v-text-field
                      v-model="info.vehicle.model"
                      readonly
                      :rules="[(v) => !!v || 'Заполните поле']"
                      color="secondary"
                      label="Марка транспортного средства"
                      prepend-icon="mdi-car"
                      type="text"
                      @input="()=>info.vehicle.model = info.vehicle.model.toUpperCase()"
                    />
                  </v-col>
                  <v-col
                    v-if="!info.vehicle.without_vin"
                    cols="5"
                  >
                    <v-text-field

                      v-model="info.vehicle.vin"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]{17}$/.test(v) || 'VIN должен состоять только из латинских букв и цифр']"
                      readonly
                      color="secondary"
                      label="VIN"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      @input="()=>info.vehicle.vin = info.vehicle.vin.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col
                    v-if="info.vehicle.without_vin"
                    cols="5"
                  >
                    <v-text-field
                      v-model="info.vehicle.body"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]+$/.test(v) || 'Номер кузова должен состоять только из латинских букв и цифр']"
                      readonly
                      color="secondary"
                      label="Номер кузова"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      @input="()=>info.vehicle.body = info.vehicle.body.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="info.vehicle.without_vin"
                      readonly
                      color="secondary"
                      label="VIN отсутствует"
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="info.vehicle.number"
                      readonly
                      :disabled="info.vehicle.without_number"
                      color="secondary"
                      label="Госномер"
                      prepend-icon="mdi-barcode-scan"
                      @input="()=>info.vehicle.number = info.vehicle.number.toUpperCase()"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="info.vehicle.without_number"
                      readonly
                      color="secondary"
                      label="Отсутствует"
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="info.vehicle.date"
                      readonly
                      color="secondary"
                      type="number"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      label="Год выпуска ТС"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model="info.vehicle.doc_type"
                      readonly
                      :rules="[(v) => !!v || 'Заполните поле']"
                      :items="select.doc_type"
                      color="secondary"
                      label="Тип документа"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="info.vehicle.doc.series"
                      readonly
                      :counter="4"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение!']"
                      color="secondary"
                      label="Серия документа"
                      prepend-icon="mdi-file-document-box"
                      maxlength="4"
                      @input="()=>info.vehicle.doc.series = info.vehicle.doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="info.vehicle.doc.number"
                      readonly
                      :counter="6"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Номер документа"
                      maxlength="6"
                      @input="()=>info.vehicle.doc.number = info.vehicle.doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="info.vehicle.doc.date"
                      readonly
                      type="date"
                      label="Дата выдачи"
                    />
                  </v-col>
                </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row dense>
              <v-col cols="12">
                Страховые полиса
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4">
                <v-select
                  label="Выберите ТС"
                  v-if="$store.state.user.role !=3"
                  :disabled="view"
                  min-width="150"
                  color="secondary"
                  :items="form.vehicles"
                  item-value="id"
                  v-model="dialog.insurance_list.vehicle"
                >
                <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.model }} {{ item.vin }} </v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.model }} {{ item.vin }} </v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                </v-select>
              </v-col>
              <v-col cols="2">
                <v-btn
                class="mt-3"
                  :disabled="view || !dialog.insurance_list.vehicle"
                  min-width="150"
                  color="secondary"
                  @click="show_insurance_list_dialog"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-data-table
                  :headers="table.insurance.headers"
                  :items="form.insurances"
                  @click:row="(item)=>info.insurance = item"
                >
                  <template v-slot:item.actions="{item}">
                    <v-icon
                      :disabled="view"
                      @click="show_insurance_show_dialog(item)"
                    >
                      mdi-cog
                    </v-icon>
                    <v-icon
                      :disabled="view"
                      @click="form.insurances = form.insurances.filter(a=>a!=item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <template v-slot:item.insurer="{item}">
                    {{ item.insurer_text }}<br>
                    {{ item.doc.series }} {{ item.doc.number }}
                  </template>
                  <template v-slot:item.driver="{item}">
                    <div v-if="item.driver_item">
                      {{ item.driver_item.surname }} {{ item.driver_item.name }} {{ item.driver_item.patronymic }}<br>
                      {{ item.driver_item.phone }}
                    </div>
                  </template>
                  <template v-slot:item.vehicle="{item}">
                    <div v-if="item.vehicle_item">
                      {{ item.vehicle_item.model }} {{ item.vehicle_item.number }}<br>
                      {{ item.vehicle_item.vin }}
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="info.insurance.insurer"
                  readonly
                  :items="select.insurer"
                  color="secondary"
                  label="Страховая"
                  :disabled="view"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="info.insurance.doc.series"
                  readonly
                  color="secondary"
                  label="Серия"
                  :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{3}$/.test(v) || 'Неверное значение']"
                  prepend-icon="mdi-car"
                  :counter="3"
                  maxlength="3"
                  :disabled="view"
                  @input="()=>info.insurance.doc.series = info.insurance.doc.series.toUpperCase().substring(0,3)"
                />
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model="info.insurance.doc.number"
                  readonly
                  color="secondary"
                  label="Номер полиса"
                  :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{10}$/.test(v) || 'Неверное значение']"
                  :counter="10"
                  maxlength="10"
                  :disabled="view"
                  @input="()=>info.insurance.doc.number = info.insurance.doc.number.toUpperCase().substring(0,10)"
                />
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="info.insurance.doc.date"
                  readonly
                  color="secondary"
                  type="date"
                  label="Срок действия"
                  prepend-icon="mdi-car"
                  :disabled="view"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="info.insurance.kasko"
                  readonly
                  color="secondary"
                  label="КАСКО"
                  :disabled="view"
                />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :items="form.contracts"
                      :headers="table.contract.headers"
                    >
                      <template v-slot:item.action="{ item }">
                        <v-icon
                          large
                          color="primary"
                          class="mr-2"
                          @click="$router.push('/contract/list/?id=' + item.id)"
                        >
                          mdi-cog
                        </v-icon>
                        {{ item.state_string }}
                      </template>
                      <template v-slot:item.number="{item}">
                        <div class="table_item">
                          <span class="table_item__title">
                            {{ item.number }}/{{ format(item.date).replace(".","").substring(0,4) }} от {{ format(item.date) }}
                          </span><br>
                          <span class="table_item__subtitle">
                            {{ item.kind_string }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.owner="{item}">
                        <span class="table_item">
                          <span class="table_item__title">
                            {{ item.owner.surname }} {{ item.owner.name }} {{ item.owner.patronymic }}
                          </span><br>
                          <span class="table_item__subtitle">
                            {{ item.owner.birthday }} г.р.
                          </span><br>
                          <span class="table_item__subtitle">
                            {{ item.owner.phone }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.transaction="{item}">
                        <v-icon
                          :color="get_color(item,1)"
                          @click="$router.push('/transaction/list?contract=' + item.number + '/' + item.date_number)"
                        >
                          mdi-credit-card-refund
                        </v-icon>
                        <v-icon
                          :color="get_color(item,2)"
                          @click="$router.push('/transaction/list?contract=' + item.number + '/' + item.date_number)"
                        >
                          mdi-credit-card-marker-outline
                        </v-icon>
                        <v-icon
                          v-if="get_color(item,3)!='white'"
                          :color="get_color(item,3)"
                          @click="$router.push('/transaction/list?contract=' + item.number + '/' + item.date_number)"
                        >
                          mdi-alert-decagram
                        </v-icon>
                      </template>
                      <template v-slot:item.sum="{item}">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ Number(item.sum).money() }}
                          </span><br>
                          <span class="table_item__subtitle">
                            Сумма договора
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.vehicle="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ item.accident_item.first.vehicle.model }}, госномер: {{ item.accident_item.first.vehicle.number }}
                          </span><br>
                          <span class="table_item__subtitle">
                            {{ item.accident_item.first.vehicle.vin }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.insurance="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ dict.insurer[item.insurer] }}
                          </span><br>
                          <span class="table_item__title text-uppercase">
                            {{ item.accident_item.first.insurance.doc.series }} {{ item.accident_item.first.insurance.doc.number }}
                          </span><br>
                          <span class="table_item__subtitle">
                            {{ item.insurer_contract }}
                          </span>
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :items="form.accidents"
                      :headers="table.accident.headers"
                    >
                      <template v-slot:item.driver="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ item.first.driver.surname }} {{ item.first.driver.name }} {{ item.first.driver.patronymic }}
                          </span>
                          <span class="table_item__subtitle">
                            ВУ {{ item.first.driver.driver_doc.series }} {{ item.first.driver.driver_doc.number }}
                          </span>
                        </div>
                        <div
                          v-if="item.second"
                          class="table_item"
                        >
                          <span class="table_item__title text-uppercase">
                            {{ item.second.driver.surname }} {{ item.second.driver.name }} {{ item.second.driver.patronymic }}
                          </span>
                          <span class="table_item__subtitle">
                            ВУ {{ item.second.driver.driver_doc.series }} {{ item.second.driver.driver_doc.number }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.owner="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ item.first.owner.surname }} {{ item.first.owner.name }} {{ item.first.owner.patronymic }}
                          </span>
                          <span class="table_item__subtitle">
                            {{ item.first.insurance.doc.series }} {{ item.first.insurance.doc.number }}
                          </span>
                        </div>
                        <div
                          v-if="item.second"
                          class="table_item"
                        >
                          <span class="table_item__title text-uppercase">
                            {{ item.second.owner.surname }} {{ item.second.owner.name }} {{ item.second.owner.patronymic }}
                          </span>
                          <span class="table_item__subtitle">
                            {{ item.second.insurance.doc.series }} {{ item.second.insurance.doc.number }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.phone="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ item.first.driver.phone }}
                          </span>
                          <span class="table_item__subtitle" />
                        </div>
                        <div
                          v-if="item.second"
                          class="table_item"
                        >
                          <span class="table_item__title text-uppercase">
                            {{ item.second.driver.phone }}
                          </span>
                          <span class="table_item__subtitle" />
                        </div>
                      </template>
                      <template v-slot:item.vehicle="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ item.first.vehicle.model }}, госномер: {{ item.first.vehicle.number }}
                          </span>
                          <span class="table_item__subtitle">
                            {{ item.first.vehicle.vin }}
                          </span>
                        </div>
                        <div
                          v-if="item.second"
                          class="table_item"
                        >
                          <span class="table_item__title text-uppercase">
                            {{ item.second.vehicle.model }}, госномер: {{ item.second.vehicle.number }}
                          </span>
                          <span class="table_item__subtitle">
                            {{ item.second.vehicle.vin }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.common="{ item }">
                        <div class="table_item">
                          <span class="table_item__title text-uppercase">
                            {{ item.common.date_formatted }} {{ item.common.time }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.settings="{ item }">
                        <v-icon
                          color="primary"
                          large
                          class="mr-2"
                          @click="$router.push('/accident/list/?id=' + item.id)"
                        >
                          mdi-cog
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-card
                  class="elevation-1"
                  text
                >
                  <v-progress-linear
                    class="ma-0"
                    color="secondary"
                    :indeterminate="loader.show"
                  />
                  <v-card-text>
                    <v-data-table
                      hide-default-footer
                      hide-default-header
                      :items="form.files"
                      :headers="table.headers"
                    >
                      <template v-slot:item.save="{item}">
                        <v-icon @click="getDoc(item)">
                          mdi-content-save
                        </v-icon>
                      </template>
                      <template v-slot:item.comment="{item}">
                        <v-text-field
                          v-model="item.comment"
                          :disabled="loader.show || view"
                          label="Описание"
                        />
                      </template>
                      <template v-slot:item.type="{item}">
                        <v-select
                          v-model="item.type"
                          :disabled="loader.show || view"
                          label="Тип"
                          :items="select.file_type"
                        />
                      </template>
                      <template v-slot:item.action="{item}">
                        <v-icon @click="form.files = form.files.filter(a=>a!=item)">mdi-delete</v-icon>
                      </template>
                      <template v-slot:item.created="{item}">
                        {{format(item.created)}}
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="grey lighten-4">
                    <v-btn
                      color="primary"
                      text
                      :disabled="loader.show || view"
                      @click="$refs.upload.click()"
                    >
                      Добавить файл
                    </v-btn>
                    <input
                      ref="upload"
                      type="file"
                      style="display: none;"
                      @change="upload"
                    >
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-tab-item>
        </base-material-tabs>
        <v-row>
          <v-col
            cols="6"
          >
            <v-btn
            v-if="!profile"
              color="secondary"
              large
              min-width="100"
              @click="$emit('close')"
            >
              Назад
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="text-right"
          >
            <v-btn
              v-if="change"
              color="primary"
              large
              min-width="100"
              @click="save_client"
              :disabled="!valid.valid"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="create"
              color="primary"
              large
              min-width="100"
              @click="create_client"
            >
              Создать
            </v-btn>
            <font color="red" class="ml-10">
              {{ valid.msg }}
            </font>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>

    <v-col
      v-if="view"
      cols="12"
      md="4"
    >
      <base-material-tabs color="warning">
        <v-tab v-if="($store.state.user.role == 1 || $store.state.user.role == 2 || $store.state.role == 3 || $store.state.user.role == 5)">
          События
        </v-tab>
        <v-tab v-if="($store.state.user.role == 1 || $store.state.user.role == 2)">
          Изменения
        </v-tab>
        <v-tab-item v-if="($store.state.user.role == 1 || $store.state.user.role == 2 || $store.state.role == 3 || $store.state.user.role == 5)">
          <base-material-card
          class="v-card-profile"
          title="События"
        >
          <v-card-text>
            <div
              v-for="(item,index) in events"
              :key="index"
              style="cursor: pointer"
            >
              <event-form
                v-if="index == active"
                :create="false"
                :view="false"
                :change="true"
                :data="item"
                :show="true"
                :short="true"
                @close="load_events()"
              />
              <v-row v-else  @click="active = index" class="select_row">
                <v-col cols="2">
                  <v-icon large :color="item.color">{{ $store.state.dict.events[item.type].icon }}</v-icon>
                </v-col>
                <v-col cols="4">
                  <font :color="item.color">{{ $store.state.dict.events[item.type].name }} {{ item.start }}<br></font>
                  <font color="#db7093"><span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span><br></font>
                  <b>{{dict.state[item.state]}}</b>
                  
                </v-col>
                <v-col cols="6">
                  <font color="blue">{{item.text}}</font>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              min-width="100"
              @click="showCreateEvent"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
        <base-material-card
          color="success"
          class="v-card-profile"
          title="Комментарии"
        >
          <v-card-text>
            <v-data-table
              :items="comments"
              :headers="headers.comment"
              hide-default-header
              :footerProps="datatable_footer"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
              </template>
              <template v-slot:item.created="{item}">
                {{item.created}}<br>
                <font color="#db7093">{{item.creator_name}}</font>
              </template>
              <template v-slot:item.text="{item}">
                <font color="blue">{{item.text}}</font>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="comment"
                  label="Введите комментарий"
                />
              </v-col>
              <v-col cols="4">
                <v-btn
                  :disabled="!comment || comment.length == 0"
                  color="primary"
                  @click="create_comment"
                >
                  <span class="mx-5">Добавить</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </base-material-card>
        </v-tab-item>
        <v-tab-item v-if="($store.state.user.role == 1 || $store.state.user.role == 2)">
          <base-material-card
            class="v-card-profile"
            title="История изменений"
          >
            <v-card-text>
              <v-list-group
                v-for="(log,index) in form.logs"
                :key="index"
              >
                <v-list-item
                  slot="activator"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ dict.log[log.type] }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="log.user">
                      {{ log.user.surname }} {{ log.user.name }} {{ log.user.patronymic }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ log.date_text }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card>
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <pre class="ma-5"><code class="json">{{ log.diff }}</code></pre>
                  </v-row>
                </v-card>
              </v-list-group>
            </v-card-text>
          </base-material-card>
        </v-tab-item>
      </base-material-tabs>
    </v-col>
    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load_events()"
      />
    </v-dialog>
    <v-dialog v-model="dialog.insurance.show" persistent>
      <InsuranceForm
        :create="false"
        :view="dialog.insurance.view"
        :change="dialog.insurance.change"
        :show="dialog.insurance.show"
        :vehicle="dialog.insurance.vehicle"
        :data="dialog.insurance.data"
        @close="dialog.insurance.show = false"
      />
    </v-dialog>
    <v-dialog v-model="dialog.vehicle.show" persistent>
        <VehicleForm
          :create="false"
          :view="dialog.vehicle.view"
          :change="dialog.vehicle.change"
          :show="dialog.vehicle.show"
          :data="dialog.vehicle.data"
          @close="dialog.vehicle.show = false"
        />
      </v-dialog>
      <v-dialog v-model="dialog.insurance_list.show" persistent>
      <InsuranceList
        :show="dialog.insurance_list.show"
        :vehicle="dialog.insurance_list.vehicle"
        :multiple="true"
        :choose="true"
        @close="dialog.insurance_list.show = false"
        @select="insurance_select"
      />
    </v-dialog>
    <v-dialog v-model="dialog.vehicle_list.show" persistent>
        <VehicleList
          :show="dialog.vehicle_list.show"
          :multiple="true"
          :choose="true"
          @close="dialog.vehicle_list.show = false"
          @select="vehicle_select"
        />
      </v-dialog>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  //import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import suggest from 'suggestions-jquery'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  import EventForm from './../EventForm'
  export default {
    components: { EventForm },
    props: ['create', 'change', 'view', 'show', 'item', 'profile', 'id'],
    data: () => ({
      comments: [],
      headers: {
          comment: [
            {
              value: 'created'
            },
            {
              value: 'creator_name'
            },
            {
              value: 'text'
            }
          ]
        },
      event: {
        items: [],
        form: {
          type: 0,
          client: '',
        },
      },
      selected: {
        insurance: null,
        vehicle: null
      },
      info: {
        insurance: {
          doc: {}
        },
        vehicle: {
          doc: {}
        }
      },
      loader: {
        show: false,
      },
      dialog: {
        insurance: {
          show: false,
          create: false,
          change: false,
          view: false,
          data: {},
        },
        insurance_list: {
          show: false,
          vehicle: null
        },
        vehicle_list: {
          show: false,
          vehicle: null
        },
        event: {
          show: false,
          item: {},
        },
        vehicle: {
            show: false,
            create: false,
            change: false,
            view: false,
            data: {},
          },
      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Дата',
            value: 'created'
          },
          {
            text: 'Описание',
            value: 'comment',
          },
          {
            text: 'Тип',
            value: 'type'
          },
          {
            text: 'Действие',
            value: 'action'
          }
        ],
        vehicle: {
          headers: [
            {
              text: 'Модель',
              value: 'model',
            },
            {
              text: 'VIN',
              value: 'vin',
            },
            {
              text: 'Номер',
              value: 'number',
            },
            {
              text: 'Серия СТС',
              value: 'doc.series',
            },
            {
              text: 'Номер СТС',
              value: 'doc.number',
            },
            {
                      text: 'Действие',
                      value: 'actions',
                    },
          ],
        },
        insurance: {
          headers: [
                    {
                      text: 'Страхователь',
                      value: 'insurer',
                    },
                    {
                      text: 'Срок действия',
                      value: 'doc.date',
                    },
                    {
                      text: 'Водитель',
                      value: 'driver',
                    },
                    {
                      text: 'Автомобиль',
                      value: 'vehicle',
                    },
                    {
                      text: 'Действие',
                      value: 'action',
                    },],
        },
        accident: {
          headers: [
            {
              text: 'Действия',
              value: 'settings',
            },
            {
              text: 'Дата и время происшествия',
              value: 'common',
            },
            {
              text: 'Телефоны',
              value: 'phone',
            },
            {
              text: 'Участники',
              value: 'driver',
            },
            {
              text: 'Собственники (страховые полисы)',
              value: 'owner',
            },
            {
              text: 'Автомобили',
              value: 'vehicle',
            },
          ],
        },
        contract: {
          headers: [{
                      sortable: false,
                      text: 'Действия',
                      value: 'action',
                    },
                    {
                      text: 'Договор',
                      value: 'number',
                    },
                    {
                      text: 'Свойства',
                      value: 'transaction',
                    },
                    {
                      text: 'Сумма',
                      value: 'sum',
                    },
                    {
                      text: 'Собственник',
                      value: 'owner',
                    },
                    {
                      text: 'ТС',
                      value: 'vehicle',
                    },
                    {
                      text: 'Страховой полис',
                      value: 'insurance',
                    }],
        },
      },
      tabs: [
        'Основное',
        'Адрес',
        'Контактные данные',
        'Документы',
        'Профили соц. сетей',
        'Банковские реквизиты',
        'Транспортные средства',
        'Страховые полисы',
        'Договора',
        'ДТП',
      ],
      data: {
        phone: '',
      },
      form: {
        insurer_agent: false,
        contract_agent: false,
        agent_doc: {},
        logs: [],
        files: [],
        type: 1,
        surname: '',
        name: '',
        patronymic: '',
        email: '',
        birthday: null,
        birthplace: '',
        phones: [],
        documents: [],
        cities: [],
        addresses: [
          {
            index: 1,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 1,
            suggestion: false,
          },
          {
            index: 2,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 2,
            suggestion: false,
          },
        ],
        requisites: {
          name: '',
          rs: '',
          ks: '',
          bic: '',
        },
        socials: [],
      },
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Адрес по прописке',
          2: 'Адрес проживания',
        },
        log: {
          1: 'Создание',
          2: 'Изменение',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
      },
      select: {
        insurances: [],
        insurer: [],
        cities: [],
        phone: [
          { value: 1, text: 'Мобильный' },
          { value: 2, text: 'Домашний' },
        ],
        document: [
          { value: 1, text: 'Паспорт' },
          { value: 2, text: 'Водительское удостоверение' },
          { value: 10, text: 'Иное' },
        ],
        type: [
          { value: 1, text: 'Собственник ТС' },
          { value: 2, text: 'Водитель' },
          { value: 3, text: 'Сотрудник компании'},
          { value: 4, text: 'Страхователь'},
          { value: 10, text: 'Иное' },
        ],
        social: [
          { value: 1, text: 'ВКонтакте' },
          { value: 2, text: 'Facebook' },
          { value: 3, text: 'Instagram' },
          { value: 4, text: 'Twitter' },
        ],
        event: [
          { value: 1, text: 'Звонок' },
        ],
        doc_type: [
            { value: 1, text: 'Свидетельство о регистрации ТС' },
            { value: 2, text: 'Паспорт ТС' },
            { value: 3, text: 'Паспорт самоходной машины' },
            { value: 4, text: 'Аналогичный документ' },
          ],
          file_type: [],
          agent_doc_type: [
            {value: 1, text: 'Устав'},
            {value: 2, text: 'Доверенность'}
          ]
      },
      suggestion: {
        bank: false,
      },
    }),
    computed: {
      valid: {
        get() {
          if (this.form.insurer_agent || this.form.contract_agent) {
            let valid = false
            for (let x in this.form.files) {
              if (this.form.files[x].type> 0 && this.$store.state.dict.file_type[this.form.files[x].type].copy) {
                valid = true
              }
            }
            if (!valid) return { valid: false, msg: 'Необходимо загрузить доверенности' }
          }
          if (this.form.name) return { valid: true }
          return { valid: false, msg: 'Не заполнены все поля' }
        }
      },
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      'view': function () {
        if (this.view) this.load()
      },
      'change': function () {
        if (this.change) this.load()
      },
      'data.phone': function () {
        if (this.data.phone) {
          var phone = this.form.phones.find(a => a.main)
          if (phone) {
            phone.number = this.data.phone
          } else {
            this.form.phones.push({ number: this.data.phone, main: true, type: 1 })
          }
        }
      },
      'show': function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
            this.load_comments()
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
            this.load_comments()
          }
          if (this.create) {
            this.form = {
              insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              cities: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              bank: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [],
            }
          }
        }
      },
    },
    mounted: function () {
      for (let x in this.$store.state.dict.file_type) {
        this.select.file_type.push({ value: Number(x), text: this.$store.state.dict.file_type[x].name })
      }
      for (let x in this.$store.state.dict.cities) {
        this.select.cities.push({ value: this.$store.state.dict.cities[x].name, text: this.$store.state.dict.cities[x].name })
      }
      for (let x in this.$store.state.dict.insurer) {
        this.dict.insurer[Number(x)] = this.$store.state.dict.insurer[x].name
        this.select.insurer.push({value: Number(x), text: this.$store.state.dict.insurer[x].name})
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      if (this.$route.params.id && (this.view || this.change)) id = this.$route.params.id
      if (this.id) id = this.id
      if (id) {
        this.axios.post('/api/clients/get', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data
              this.form.files = this.form.files || []
              if (this.form.birthday) this.form.birthday = moment(this.form.birthday).format('YYYY-MM-DD')
              this.form.requisites = this.form.requisites || {}
              if (this.form.phones.find(a => a.main && a.type == 1)) {
                this.data.phone = this.form.phones.find(a => a.main && a.type == 1).number
              }
              for (let x in this.form.insurances) {
                this.form.insurances[x].doc.date = moment(this.form.insurances[x].doc.date).format('YYYY-MM-DD')
              }
              for (let x in this.form.vehicles) {
                this.form.vehicles[x].doc.date = moment(this.form.vehicles[x].doc.date).format('YYYY-MM-DD')
              }
              this.form.cities = this.form.cities || []
              this.form.logs = this.form.logs || []
              this.form.logs = this.form.logs.reverse()
              for (let x in this.form.logs) {
                this.form.logs[x].date_text = moment(this.form.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.form.logs[x].diff = updatedDiff(JSON.parse(this.form.logs[x].old), JSON.parse(this.form.logs[x].change))
              }
              this.form.agent_doc = this.form.agent_doc || {}
              if (this.form.agent_doc.date) this.form.agent_doc.date = moment(this.form.agent_doc.date).format('YYYY-MM-DD')
              if (this.form.agent_doc.from_date) this.form.agent_doc.from_date = moment(this.form.agent_doc.from_date).format('YYYY-MM-DD')
              this.load()
              this.load_vehicles()
              this.load_events()
            }
          })
          .catch(e => {

          })
      }
    },
    methods: {
      create_comment: function() {
        this.$axios.post('/api/comment/create', {
          text: this.comment,
          entity: this.form.id
        })
        .then(response=> {
          if (!response.data.error) {
            this.comment = ""
            this.$store.commit('snackbar', 'Успешно')
            this.load_comments()
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при сохранении данных')
        })
      },
      load_comments: function () {
        this.axios.post('/api/comment/list', {
          entity: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].created = moment(result.data.data[x].created).format('DD.MM.YYYY HH:mm:ss')
                result.data.data[x].creator_name = (result.data.data[x].creator.surname || "") + " " + (result.data.data[x].creator.name || "") + " " + (result.data.data[x].creator.patronymic || "")
              }
              this.comments = result.data.data
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      format: function(date) {
        if (!date) return ''
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      doc_from_input: function(item, index) {
        if (item.type != 1) {
          item.suggestion = false
          return
        }
        console.log($('[name=doc_from_' + String(index) + ']'))
        if (!item.suggestion) {
          if (!item.suggestion && $('[name=doc_from_' + String(index) + ']').length > 0) {
            item.suggestion = true
            $('[name=doc_from_' + String(index) + ']').suggestions({
              token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
              type: 'fms_unit',
              count: 5,
              onSelect: data => {
                item.code = data.data.code
                item.from = data.data.name
              },
            })
          }
        }
      },
      show_vehicle_list_dialog: function () {
        this.dialog.vehicle_list.show = true
      },
      show_vehicle_show_dialog: function (data) {
        this.dialog.vehicle.data = data
        this.dialog.vehicle.create = false
        this.dialog.vehicle.change = false
        this.dialog.vehicle.view = true
        this.dialog.vehicle.show = true
      },
      vehicle_select: function(data) {
        this.dialog.vehicle_list.show = false
        this.form.vehicles = this.form.vehicles || []
        for (let x in data) {
          this.form.vehicles.push(data[x])
            }
      },
      show_insurance_list_dialog: function () {
        this.dialog.insurance_list.show = true
      },
      show_insurance_show_dialog: function (data) {
        this.dialog.insurance.data = data
        this.dialog.insurance.create = false
        this.dialog.insurance.change = false
        this.dialog.insurance.view = true
        this.dialog.insurance.show = true
      },
      insurance_select: function(data) {
        this.dialog.insurance_list.show = false
        this.form.insurances = this.form.insurances || []
        for (let x in data) {
          this.form.insurances.push(data[x])
        }
      },
      get_color: function (item, type) {
        if (!item.transactions) { return 'red' }
        if (type == 1) {
          var transactions = item.transactions.filter(a => a.type == this.dict.type['client'] && a.state != 8)
          if (transactions.length == 0) return 'red'
          let color = 'green'
          for (let x in transactions) {
            if (transactions[x].state == 1) { color = 'yellow' }
          }
          return color
        }
        if (type == 2) {
          var transactions = item.transactions.filter(a => a.type == this.dict.type['insurer'] && a.state != 8)
          if (transactions.length == 0) return 'red'
          let color = 'green'
          for (let x in transactions) {
            if (transactions[x].state == 1) { color = 'yellow' }
          }
          return color
        }
        if (type == 3) {
          var transactions = item.transactions.filter(a => a.type == this.dict.type['insurer'] && a.state == 1)
          if (transactions.length > 0) {
            let color = 'white'
            for (let x in transactions) {
              if (moment().diff(moment(transactions[x].created), 'days') > 15) { color = 'yellow' }
              if (moment().diff(moment(transactions[x].created), 'days') > 20) { color = 'red' }
            }
            return color
          } else {
            return 'white'
          }
        }
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          client: this.$route.params.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                if (result.data.data[x].type > 0) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type > 0) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          client: this.form.id,
          client_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      getDoc: function (item) {
        console.log(item)
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      load: function () {
        this.event.form.client = this.form.id
        this.axios.post('/api/event/list', this.event.form)
          .then(response => {
            if (response.data.error) {
              this.$store.commit('snackbar', 'Ошибка')
            } else {
              for (let x in response.data.data) {
                response.data.data[x].date_text = moment(response.data.data[x].date).format('DD.MM.YYYY')
                response.data.data[x].create_text = moment(response.data.data[x].create).format('DD.MM.YYYY HH:mm')
              }
              this.event.items = response.data.data
            }
            this.loader.show = false
          })
          .catch(error => {
            this.$store.commit('snackbar', 'Ошибка')
            this.loader.show = false
          })
      },
      open_file: function (id, item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          let data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              } else {
                this.form.files = this.form.files || []
                for (let x in response.data.data)
                {
                  this.form.files.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      bank_input: function (item) {
        if (!this.suggestion.requisites) {
          this.suggestion.requisites = true
          $('[name=bank]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.requisites.name = data.data.name.full || data.data.name.payment
              this.form.requisites.bic = data.data.bic
              this.form.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      bic_input: function (item) {
        console.log('bic')
        if (!this.suggestion.bic) {
          this.suggestion.bic = true
          $('[name=bic]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.requisites.name = data.data.name.full || data.data.name.payment
              this.form.requisites.bic = data.data.bic
              this.form.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      adress_input: function (item, index) {
        if (!item.suggestion) {
          console.log('[name=address' + String(index) + ']')
          item.suggestion = true
          $('[name=address' + String(index) + ']').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              item.value = data.unrestricted_value
              item.data = data.data
              console.log(item)
            },
          })
        }
      },
      create_client: function () {
        this.$emit('create', this.form)
      },
      save_client: function () {
        if (this.form.id) {
          this.axios.post('/api/clients/save', this.form)
            .then(result => {
              if (!result.data.error) {
                console.log(result)
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                if (!this.profile) this.$router.push('/clients/view/' + this.form.id)
              } else {
                this.$store.commit('snackbar', result.data.error || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else { this.$emit('change', this.form) }
      },
    },
  }
</script>
